export interface FieldChange {
  label: string
  from: string
  to: string
}

export function formatFieldValue(value: unknown): string {
  if (value == null || value === '') return '(empty)'
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  if (typeof value === 'number') return String(value)
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value).trim()
}

export function diffSnapshots(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  labels: Record<string, string>
): FieldChange[] {
  const changes: FieldChange[] = []

  for (const key of Object.keys(labels)) {
    const from = formatFieldValue(before[key])
    const to = formatFieldValue(after[key])
    if (from !== to) {
      changes.push({ label: labels[key], from, to })
    }
  }

  return changes
}

export function buildUpdateDescription(
  entityName: string,
  changes: FieldChange[],
  maxFields = 8
): string {
  if (changes.length === 0) {
    return `${entityName} updated`
  }

  const shown = changes.slice(0, maxFields)
  const parts = shown.map((change) => `${change.label}: ${change.from} → ${change.to}`)
  let description = `Updated ${entityName}: ${parts.join('; ')}`

  if (changes.length > maxFields) {
    description += `; +${changes.length - maxFields} more`
  }

  return description
}
